import { NextTermPlanningCtrl } from './next-term-planning.controller';

export const NextTermPlanningComponent = {
  bindings: {
    gapPlans: '<',
    currentSchool: '<',
    currentUser: '<',
  },
  controller: NextTermPlanningCtrl,
  template: require('./next-term-planning.html'),
};
